import React, { useMemo, type FC } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import Alert from 'wix-ui-icons-common/on-stage/Alert';
import Info from 'wix-ui-icons-common/on-stage/Info';
import Select from 'wix-ui-icons-common/on-stage/Select';
import {
  SectionNotification,
  SectionNotificationType,
  Text,
  IconButton,
  TextTypography,
  IconButtonThemes,
} from 'wix-ui-tpa/cssVars';
import { useWidgetSelector } from '@app/hooks';
import {
  selectAdUnit,
  selectNotificationType,
} from '@app/store/widget/slices/widget-slice';
import { st, classes } from '../Widget.st.css';

const ICON_SIZE = { width: 24, height: 24 };

const notificationIcon: Partial<Record<SectionNotificationType, JSX.Element>> =
  {
    [SectionNotificationType.success]: <Select {...ICON_SIZE} />,
    [SectionNotificationType.alert]: <Alert {...ICON_SIZE} />,
    [SectionNotificationType.default]: <Info {...ICON_SIZE} />,
  };

const AdsenseNotification: FC = () => {
  const { t } = useTranslation();
  const adUnit = useWidgetSelector(selectAdUnit);
  const notificationType = useWidgetSelector(selectNotificationType);

  const notificationText = useMemo(() => {
    return notificationType === SectionNotificationType.success
      ? t('adsense.widget.sectionNotification.adName.isConnected', {
          adName: adUnit?.displayName,
        })
      : t(`adsense.widget.sectionNotification.${notificationType}`);
  }, [notificationType, adUnit?.displayName, t]);

  return (
    <>
      <div className={classes.SectionNotificationWrapper}>
        <SectionNotification
          className={classes.SectionNotification}
          type={notificationType}
          size="compact"
        >
          <SectionNotification.Icon
            icon={notificationIcon[notificationType]}
            className={st(classes.SectionNotificationIcon, {
              defaultType: notificationType === SectionNotificationType.default,
              alertType: notificationType === SectionNotificationType.alert,
              successType: notificationType === SectionNotificationType.success,
            })}
          />
          <SectionNotification.Text
            className={classes.SectionNotificationIconText}
          >
            {notificationText}
          </SectionNotification.Text>
        </SectionNotification>
      </div>
      <div className={classes.TitleHeaderSmallPreset}>
        <Text typography={TextTypography.runningText}>
          {t('adsense.widget.title_small_preset')}
        </Text>
        <IconButton
          className={st(classes.IconButton, {
            defaultType: notificationType === SectionNotificationType.default,
            alertType: notificationType === SectionNotificationType.alert,
            successType: notificationType === SectionNotificationType.success,
          })}
          icon={notificationIcon[notificationType]}
          theme={IconButtonThemes.Box}
        />
      </div>
    </>
  );
};
export default AdsenseNotification;
